import { gql } from '@apollo/client';

export const CREATE_AD_INTEGRATION_NOTE = gql`
  mutation CreateAdIntegrationNote($request: CreateAdIntegrationNoteRequest!) {
    CreateAdIntegrationNote(request: $request) {
      id
    }
  }
`;

export const DELETE_AD_INTEGRATION_NOTE = gql`
  mutation DeleteAdIntegrationNote($id: String!) {
    DeleteAdIntegrationNote(id: $id)
  }
`;

export const INTEGRATION_DECLINE_STOP_PUBLISH = gql`
  mutation DeclineStopPublish(
    $id: String!
    $request: DeclineStopPublishRequest!
  ) {
    DeclineStopPublish(id: $id, request: $request) {
      id
      approval_status
      rejection_note
    }
  }
`;

export const INTEGRATION_APPROVE_STOP_PUBLISH = gql`
  mutation ApproveStopPublish(
    $id: String!
    $request: ApproveStopPublishRequest!
  ) {
    ApproveStopPublish(id: $id, request: $request) {
      id
      approval_status
      rejection_note
    }
  }
`;

export const INTEGRATION_APPLY_FOR_STOP_PUBLISH = gql`
  mutation ApplyForStopPublish($id: String!) {
    ApplyForStopPublish(id: $id) {
      id
      approval_status
    }
  }
`;

export const INTEGRATION_APPLY_FOR_PUBLISH = gql`
  mutation ApplyForPublish($id: String!) {
    ApplyForPublish(id: $id) {
      id
      approval_status
    }
  }
`;

export const DECLINE_AD_INTEGRATION = gql`
  mutation DeclineAdIntegration($id: String!, $rejection_note: String!) {
    DeclineAdIntegration(id: $id, approval_note: $rejection_note) {
      id
      approval_status
      rejection_note
      approved_by
    }
  }
`;

export const APPROVE_AD_INTEGRATION = gql`
  mutation ApproveAdIntegration($id: String!, $approval_notes: String!) {
    ApproveAdIntegration(id: $id, approval_note: $approval_notes) {
      id
      approval_status
      approval_note
      approved_by {
        id
      }
    }
  }
`;

export const CREATE_INTEGRATION_DRAFT = gql`
  mutation CreateIntegrationDraft($request: CreateIntegrationDraftRequest!) {
    CreateIntegrationDraft(request: $request) {
      id
    }
  }
`;

export const UPDATE_AD_INTEGRATION_SOCMED_DATA = gql`
  mutation UpdateAdIntegrationSocmedData(
    $id: String!
    $request: UpdateAdIntegrationSocmedDataRequest!
  ) {
    UpdateAdIntegrationSocmedData(id: $id, request: $request) {
      id
      socmed_campaign_local
      socmed_ad_set_local
      socmed_ad_local
    }
  }
`;

export const UPDATE_INTEGRATION_DRAFT = gql`
  mutation UpdateIntegrationDraft(
    $id: String!
    $request: UpdateIntegrationDraftRequest!
  ) {
    UpdateIntegrationDraft(id: $id, request: $request) {
      id
    }
  }
`;
